import { useState } from "react";
import { Menu, MessageCircle } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { Logo } from "@/components/site/Logo";
import { useSite } from "@/context/SiteContext";

export const NAV = [
  { href: "#beranda", label: "Beranda", id: "beranda" },
  { href: "#layanan", label: "Layanan", id: "layanan" },
  { href: "#paket", label: "Paket & Promo", id: "paket", key: "packages" },
  { href: "#harga", label: "Daftar Harga", id: "harga" },
  { href: "#dokumentasi", label: "Dokumentasi", id: "dokumentasi" },
  { href: "#testimoni", label: "Testimoni", id: "testimoni", key: "testimonials" },
  { href: "#faq", label: "FAQ", id: "faq", key: "faqs" },
  { href: "#kontak", label: "Kontak", id: "kontak" },
];

export const useNav = () => {
  const { site } = useSite();
  return NAV.filter((n) => !n.key || site[n.key]?.length);
};

export const Header = () => {
  const { openInquiry } = useSite();
  const nav = useNav();
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 bg-nanina-bg/90 backdrop-blur-xl border-b border-nanina-green/10" data-testid="site-header">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 h-[68px] sm:h-[80px] flex items-center justify-between gap-4">
        <Logo testId="header-logo" />
        <nav className="hidden lg:flex items-center gap-4 xl:gap-6 text-[13px] font-semibold text-[#527167]" aria-label="Navigasi utama">
          {nav.map((n) => (
            <a key={n.id} href={n.href} className="whitespace-nowrap hover:text-nanina-green transition-colors" data-testid={`nav-${n.id}`}>{n.label}</a>
          ))}
        </nav>
        <button
          onClick={() => openInquiry()}
          className="hidden lg:inline-flex shrink-0 items-center gap-2 rounded-full bg-nanina-green text-white text-[13px] font-semibold px-5 py-3 hover:bg-nanina-greendark hover:-translate-y-0.5 transition-[transform,background-color]"
          data-testid="header-whatsapp-button"
        >
          <MessageCircle className="h-4 w-4" /> Tanya Admin
        </button>
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button className="lg:hidden p-2 -mr-2 text-nanina-green" aria-label="Buka menu" data-testid="mobile-menu-button">
              <Menu className="h-6 w-6" />
            </button>
          </SheetTrigger>
          <SheetContent side="right" className="w-[78vw] max-w-xs bg-white" data-testid="mobile-menu">
            <SheetHeader><SheetTitle className="text-left text-nanina-green">Menu</SheetTitle></SheetHeader>
            <nav className="mt-6 flex flex-col gap-1" aria-label="Navigasi seluler">
              {nav.map((n) => (
                <a key={n.id} href={n.href} onClick={(e) => {
                  e.preventDefault();
                  setOpen(false);
                  setTimeout(() => document.getElementById(n.id)?.scrollIntoView({ behavior: "smooth" }), 320);
                }} className="rounded-xl px-3 py-3 font-semibold text-nanina-green hover:bg-nanina-skysoft" data-testid={`mobile-nav-${n.id}`}>{n.label}</a>
              ))}
            </nav>
            <button
              onClick={() => { setOpen(false); openInquiry(); }}
              className="mt-6 w-full inline-flex justify-center items-center gap-2 rounded-full bg-nanina-green text-white text-sm font-semibold px-5 py-3"
              data-testid="mobile-whatsapp-button"
            >
              <MessageCircle className="h-4 w-4" /> Tanya Admin via WhatsApp
            </button>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
};
